export const ColorArray = [
    { color1: "#968bf7", color2: "#1c00ff" },
    { color1: "#0ee335", color2: "#0c4f18" },
    { color1: "#edcf95", color2: "#ffa600" },
    { color1: "#faa1a0", color2: "#ff1715" },
    { color1: "#f09eef", color2: "#c900c8" },
    { color1: "#ffef15", color2: "#ce7f33" },
    { color1: "#e8a884", color2: "#88411a" },
    { color1: "#898a24", color2: "#7f8000" },
    { color1: "#b56eb5", color2: "#fe61ff" },
    { color1: "#60d6d6", color2: "#01ffff" },
    { color1: "#d2a3f0", color2: "#980eed" },
    { color1: "#D2a290", color2: "#873e23" },
    { color1: "#0271E6", color2: "#063970" },
    { color1: "#e6d57c", color2: "#ffd701" },
    { color1: "#cc7c7d", color2: "#ab0001" },
    { color1: "#e38fe3", color2: "#c900c8" },
    { color1: "#63ebeb", color2: "#01ffff" },
    { color1: "#8bf08e", color2: "#00cf07" },
    { color1: "#e3e18a", color2: "#7f8000" },
    { color1: "#7163e6", color2: "#1c00ff" },
];
